import mainAxios from "../../services/mainAxios";

export const loadOptionsForBankAccounts = async (name, contactType, includeContactsWithoutAccounts = false,idValue) => {
  const sortCriteria = [
    { field: "recordDate", direction: "DESC" }
  ];
  let bankAccounts = [];
  if (name?.length > 2 || idValue) {
    return await mainAxios
      .post("/apiEndpoint/search", {
        object: "GetConnections",
        value: null,
        params: {
          customerLiveSearch: name,
          ...(idValue ? { "idValue": idValue } : {}),
          ...(contactType ? { "contactTypes.type": contactType } : {})
        },
        sortCriteria
      })
      .then((res) => {
        if (res.data.status) {
          let filteredContacts = res.data.content;

          let contactsWithAccounts = filteredContacts
            .filter(contact => contact.accounts && contact.accounts.length > 0)
            .flatMap((contact) => {
              return contact.accounts.map((account) => {
                const bankName = account.financialInstitution?.name || "Unknown Bank";
                const accountDisplay = account.iban || account.accountNo || "No Account Number";
                return {
                  ...account,
                  label: `${contact.name} - ${bankName} - ${accountDisplay} - ${account.currency}`,
                  value: account.id,
                  contact
                };
              });
            });

          if (includeContactsWithoutAccounts) {
            let contactsWithoutAccounts = filteredContacts
              .filter(contact => !contact.accounts || contact.accounts.length === 0)
              .map((contact) => ({
                label: contact.name,
                value: `contact_${contact.id}`,
                contact,
                isContactOnly: true
              }));

            bankAccounts = [...contactsWithAccounts, ...contactsWithoutAccounts];
          } else {
            bankAccounts = contactsWithAccounts;
          }

          bankAccounts.sort((a, b) => {
            if (a.financialInstitution?.id === 1 && b.financialInstitution?.id !== 1) return -1;
            if (a.financialInstitution?.id !== 1 && b.financialInstitution?.id === 1) return 1;
            return 0;
          });
        }
        console.log({bankAccounts})
        return bankAccounts;
      });
  }
  return bankAccounts;
};



export const openBankingStatus={
  "DRAFT":{ id: 1, value: "DRAFT", label: "openBankingStatus.draft", badgeClass: "secondary" },
  "READY_FOR_APPROVAL":{ id: 2, value: "READY_FOR_APPROVAL", label: "openBankingStatus.readyForApproval", badgeClass: "info" },
  "SENT_TO_BANK":{ id: 3, value: "SENT_TO_BANK", label: "openBankingStatus.sentToBank", badgeClass: "success" },
  "PENDING":{ id: 4, value: "PENDING", label: "openBankingStatus.pending", badgeClass: "warning" },
  "DELETED":{ id: 5, value: "DELETED", label: "openBankingStatus.deleted", badgeClass: "danger" },
}

export const openBankingStatusById = {
  1: openBankingStatus.DRAFT,
  2: openBankingStatus.READY_FOR_APPROVAL,
  3: openBankingStatus.SENT_TO_BANK,
  4: openBankingStatus.PENDING,
  5: openBankingStatus.DELETED,
}

export const bankStatus={
  "RECEIVED":{ id: 1, value: "RECEIVED", label: "bankStatus.received", badgeClass: "info" },
  "WAITING":{ id: 2, value: "WAITING", label: "bankStatus.waiting", badgeClass: "warning" },
  "PAID":{ id: 3, value: "PAID", label: "bankStatus.paid", badgeClass: "success" },
  "REJECTED":{ id: 4, value: "REJECTED", label: "bankStatus.rejected", badgeClass: "danger" },
  "CANCELLED":{ id: 5, value: "CANCELLED", label: "bankStatus.cancelled", badgeClass: "danger" },
  "PARTIALLY_PROCESSED":{ id: 6, value: "PARTIALLY_PROCESSED", label: "bankStatus.partiallyProcessed", badgeClass: "success" },
  "OTHER":{ id: 7, value: "OTHER", label: "bankStatus.other", badgeClass: "secondary" },
}

export const bankStatusById = {
  1: bankStatus.RECEIVED,
  2: bankStatus.WAITING,
  3: bankStatus.PAID,
  4: bankStatus.REJECTED,
  5: bankStatus.CANCELLED,
  6: bankStatus.PARTIALLY_PROCESSED,
  7: bankStatus.OTHER,
}

export const bankStatusEmployee={
  "SUCCESS":{ id: 1, value: "SUCCESS", label: "bankStatusEmployee.success", badgeClass: "success" },
  "FAILED":{ id: 2, value: "FAILED", label: "bankStatusEmployee.failed", badgeClass: "danger" },
  "INCOMPLETE":{ id: 3, value: "INCOMPLETE", label: "bankStatusEmployee.incomplete", badgeClass: "danger" },
  "WAITING":{ id: 4, value: "WAITING", label: "bankStatusEmployee.waiting", badgeClass: "warning" },
}

export const bankStatusEmployeeById = {
  1: bankStatusEmployee.SUCCESS,
  2: bankStatusEmployee.FAILED,
  3: bankStatusEmployee.INCOMPLETE,
  4: bankStatusEmployee.WAITING,
}

export const compareStatus = (incomingStatus, statusObject, compareByField = null) => {
  if (!incomingStatus || !statusObject) return false;

  if (compareByField === null) {
    if (typeof incomingStatus === "number") {
      compareByField = "id";
    } else if (typeof incomingStatus === "string") {
      compareByField = "value";
    }
  }

  if (compareByField === "id") {
    return incomingStatus === statusObject.id;
  } else if (compareByField === "value") {
    return incomingStatus === statusObject.value;
  }

  return false;
};

export const generateStatusStyle=(incomingStatus,t)=>{
    let statusObj;

    if (typeof incomingStatus === 'number') {
      statusObj = openBankingStatusById[incomingStatus];
    } else {
      statusObj = openBankingStatus[incomingStatus];
    }

    if (statusObj) {
      return {
        badgeClass: statusObj.badgeClass,
        status: t(statusObj.label)
      };
    }

    return {
      badgeClass: "secondary",
      status: incomingStatus
    };
}

export const bankStatusStyle = (incomingStatus, t) => {
  let statusObj;

  if (typeof incomingStatus === 'number') {
    statusObj = bankStatusById[incomingStatus];
  } else {
    statusObj = bankStatus[incomingStatus];
  }

  if (statusObj) {
    return {
      badgeClass: statusObj.badgeClass,
      status: t(statusObj.label)
    };
  }

  return {
    badgeClass: "secondary",
    status: incomingStatus,
  };
};
export const bankStatusEmployeeStyle = (incomingStatus, t) => {
  if (!incomingStatus || (typeof incomingStatus === 'string' && incomingStatus.trim() === '')) {
    return null;
  }

  let statusObj;

  if (typeof incomingStatus === 'number') {
    statusObj = bankStatusEmployeeById[incomingStatus];
  } else {
    statusObj = bankStatusEmployee[incomingStatus];
  }

  if (statusObj) {
    return {
      badgeClass: statusObj.badgeClass,
      status: t(statusObj.label)
    };
  }

  return null;
};



export const openBankingVisibility=(fullCompany,user)=>(
  {
        openBankAccounts:fullCompany?.paymentWorkflow?.id==1?[2].includes(user?.paymentsRole?.id) :(fullCompany?.paymentWorkflow?.id===2?[4].includes(user?.paymentsRole?.id):false),
        bankJournal:fullCompany?.paymentWorkflow?.id==1?[2].includes(user?.paymentsRole?.id) :(fullCompany?.paymentWorkflow?.id===2?[4].includes(user?.paymentsRole?.id):false),
        paymentReciept:fullCompany?.paymentWorkflow?.id==1?[2].includes(user?.paymentsRole?.id) :(fullCompany?.paymentWorkflow?.id===2?[4].includes(user?.paymentsRole?.id):false),
        paymentOrder:fullCompany?.paymentWorkflow?.id==1?[2].includes(user?.paymentsRole?.id) :(fullCompany?.paymentWorkflow?.id===2?[4].includes(user?.paymentsRole?.id):false),
        payroll: fullCompany?.paymentWorkflow?.id==1?[2].includes(user?.paymentsRole?.id) :(fullCompany?.paymentWorkflow?.id===2?[4].includes(user?.paymentsRole?.id):false)
    }
)

export const showIbanValidation=true
